import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';
import shuffle from 'lodash/shuffle';

import Block from '../partials/Block';

const propTypes = {
    blocks: PropTypes.array,
    handle: PropTypes.string,
};

const defaultProps = {
    blocks: [],
    slug: 'media',
    handle: '',
};

class GalleryLayout extends Component {
    constructor(props) {
        super(props);

        this.ensureMediaOptions = this.ensureMediaOptions.bind(this);
    }

    // eslint-disable-next-line class-methods-use-this
    ensureMediaOptions(block) {
        const { handle } = this.props;
        return {
            ...block,
            ratio: handle === 'quotes' ? 1 : undefined,
            rounded: handle !== 'posters' && handle !== 'video',
            ...block,
            lightbox: true,
            background: (block.background || false) && handle !== 'posters',
        };
    }

    render() {
        const { blocks, handle } = this.props;

        const layoutClassName = classNames({
            'layout layout-gallery': true,
            [`layout-page-${handle}`]: true,
        });

        const mediaTypes = ['media', 'image', 'video'];
        const pageBlocks = blocks || [];

        const contentBlocks = pageBlocks.filter(block => mediaTypes.indexOf(block.type) === -1)
            .map((block, key) => {
                if (key === 0) {
                    return {
                        ...block,
                        pageTitle: true,
                    };
                }
                return block;
            });

        const mediaBlocks = shuffle(pageBlocks.filter(block => (
            mediaTypes.indexOf(block.type) !== -1
        )).map(this.ensureMediaOptions));
        const firstMediaBlocks = (mediaBlocks.length > 0 ? [mediaBlocks[0]] : []);
        const otherMediaBlocks = mediaBlocks.slice(1);

        return (
            <div className={layoutClassName}>
                <div className="partial-hero container hero-container relative">
                    <div className="cols">
                        <div className="col top">
                            <Block blocks={firstMediaBlocks} />
                        </div>
                        <div className="col bottom">
                            <div className="col-inner">
                                <Block blocks={contentBlocks} />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container container-gallery">
                    <Block blocks={otherMediaBlocks} />
                    <div className="clearfix" />
                </div>
            </div>
        );
    }
}

GalleryLayout.propTypes = propTypes;
GalleryLayout.defaultProps = defaultProps;

const GalleryLayoutContainer = connect(state => ({
    pages: state.site.pages,
}))(GalleryLayout);

export default GalleryLayoutContainer;



// WEBPACK FOOTER //
// ./components/layouts/GalleryLayout.jsx